import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import Table from '../../ui/Table';

const COLUMNS = [
  { Header: 'ID', accessor: 'id', width: 70 },
  { Header: 'Empresa', accessor: 'empresaId', width: 90 },
  { Header: 'Centro', accessor: 'centroEstudio', width: 100 },
  { Header: 'Nombre', accessor: 'nombre' },
  { Header: 'Apellidos', accessor: 'apellidos' },
  { Header: 'Email', accessor: 'email' },
  { Header: 'DNI', accessor: 'dni', width: 100 },
  { Header: 'Móvil', accessor: 'phone', width: 100 },
  {
    Header: 'Acciones',
    accessor: 'actions',
    width: 80,
  },
];

const TablaResultados = ({ data, searchMeta, onLoadMore, isLoadingMore }) => {
  const navigate = useNavigate();

  if (data === null || data.length === 0) return null;

  const handleRowClick = (row) => {
    navigate(`/alumnos/${row.empresaId}/${row.id}/detalles`);
  };

  return (
    <div style={{ marginTop: '16px' }}>
      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        marginBottom: '8px', padding: '0 4px',
      }}>
        <span style={{ fontSize: '0.8rem', fontWeight: 600, color: '#374151' }}>
          Resultados
        </span>
        <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>
          {data.length} alumno{data.length !== 1 ? 's' : ''}
          {searchMeta?.hasMore && ' (hay más resultados)'}
        </span>
      </div>

      <Table
        columns={COLUMNS}
        data={data}
        defaultPageSize={10}
        onLoadMore={onLoadMore}
        isLoadingMore={isLoadingMore}
        hasMore={searchMeta?.hasMore ?? false}
        getTrProps={(state, rowInfo) => ({
          onClick: () => rowInfo && handleRowClick(rowInfo.original),
          style: { cursor: 'pointer' },
        })}
      />
    </div>
  );
};

TablaResultados.propTypes = {
  data: PropTypes.array,
  searchMeta: PropTypes.shape({
    total: PropTypes.number,
    hasMore: PropTypes.bool,
  }),
  onLoadMore: PropTypes.func,
  isLoadingMore: PropTypes.bool,
};

export default TablaResultados;
